/**
 * KanbanSkeleton — estado de carregamento visual do board do CRM (Fase A).
 *
 * Substitui o antigo texto "Carregando pipeline..." por colunas e cards
 * fantasma com shimmer, dando feedback claro de que o pipeline esta
 * carregando. Usa a mesma classe `.kanban` (layout horizontal) e a largura
 * de coluna configurada (`--crm-col-w`) para parecer o board real.
 */
import React from "react";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
`;

export const Ghost = styled.div`
  background: var(--surface-2, #e9eaee);
  border-radius: ${({ $r = 6 }) => $r}px;
  animation: ${pulse} 1.2s ease-in-out infinite;
`;

const GhostCard = styled.div`
  background: var(--surface, #fff);
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Coluna = styled.div`
  width: var(--crm-col-w, 288px);
  min-width: var(--crm-col-w, 288px);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default function KanbanSkeleton({ colunas = 5 }) {
  return (
    <div className="kanban" aria-busy="true" aria-label="Carregando pipeline">
      {Array.from({ length: colunas }).map((_, i) => (
        <Coluna key={i}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "4px 2px" }}>
            <Ghost $r={3} style={{ width: 10, height: 10 }} />
            <Ghost style={{ width: "55%", height: 12 }} />
            <Ghost style={{ width: 22, height: 12, marginLeft: "auto" }} />
          </div>
          {Array.from({ length: (i % 3) + 1 }).map((__, j) => (
            <GhostCard key={j}>
              <Ghost style={{ width: "70%", height: 12 }} />
              <Ghost style={{ width: "40%", height: 10 }} />
              <Ghost style={{ width: "55%", height: 10 }} />
            </GhostCard>
          ))}
        </Coluna>
      ))}
    </div>
  );
}
